'use client';

import { recordClientErrorEvent } from '@/lib/client-telemetry';

// Matches client-telemetry's own stack cap so the admin feed renders both the
// same way.
const STACK_MAX_CHARS = 3_000;

/**
 * React swallows render-time throws before they reach window.onerror, so the
 * error boundaries are the only place they can be reported. Same 'js_error'
 * event name and payload keys as the window listeners in client-telemetry, so
 * /admin/telemetry/client summarizes boundary failures alongside script errors.
 *
 * Goes through the error-budget path, not the plain one: a boundary is the
 * most plausible producer of a per-frame throw loop, which is exactly what
 * that budget exists to cap. It also no-ops until the provider has started
 * telemetry, which needs a session — a boundary that fires before login
 * reports to the console only.
 */
export function reportRenderError(error: Error & { digest?: string }, boundary: string): void {
  console.error(`render error caught by ${boundary}`, error);
  recordClientErrorEvent('js_error', {
    message: String(error.message || error).slice(0, 500),
    source: boundary,
    stack: typeof error.stack === 'string' ? error.stack.slice(0, STACK_MAX_CHARS) : undefined,
    digest: error.digest,
  });
}
